import config from '../config.js';

/**
 * A media path from the API (`/uploads/x.jpg`, `uploads/x.jpg`) → a URL under
 * `config.mediaBaseUrl`; an already absolute http(s)/data/blob URL is kept.
 * Shared by the listener dashboard, the notification feed and anything else
 * that renders a band's profile image from an API row.
 */
export const resolveMediaUrl = (url) => {
  if (!url) return null;
  const raw = String(url);
  if (/^(https?:|data:|blob:)/i.test(raw)) return raw;
  const base = (config.mediaBaseUrl || '').replace(/\/$/, '');
  const path = raw.replace(/^\//, '');
  return base ? `${base}/${path}` : `/${path}`;
};
